/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Informatii suplimentare",
  "CookieMessage.old.text":
    "Utilizăm module cookie pentru a asigura o funcționare optimă a magazinului nostru online. Citiți directivele noastre referitoare la modulele cookie.",
  "CookieMessage.link": "Acceptati modulele cookie",
  "CookieMessage.more_information":
    "Citiți mai multe despre modulele cookie Kramp",
  "CookieMessage.return": "Înapoi",
  "CookieMessage.intro.body":
    'Aceste module cookie au fost plasate de Kramp, precum si de către terți. Este de la sine înțeles că avem grijă de confidențialitatea dumneavoastră. Dacă faceți clic pe mai jos pe "Accept modulele cookie", sunteți de acord cu utilizarea acestor module cookie. Acceptând aceste module cookie, vă asigurați că site-ul nostru web funcționează corect. Exemple de scopuri în care sunt utilizate acestea:',
  "CookieMessage.intro.list.1": "Conectarea automata la Contul meu",
  "CookieMessage.intro.list.2":
    "Analiza comportamentului vizitatorilor pentru îmbunatatirea site-ului web",
  "CookieMessage.intro.list.3":
    "Crearea de profiluri de client, pentru a ne permite sa va furnizam informatii si reclame personalizate",
  "CookieMessage.intro.extra":
    'Daca nu doriti sa acceptati toate modulele cookie, puteti modifica acest lucru în <a>setari</a>. Pentru mai multe informatii, cititi <a href="{legalLink}">declaratia noastra privind confidentialitatea si modulele cookie</a>.',
  "CookieMessage.intro.title": "Kramp utilizeaza module cookie",
  "CookieMessage.settings.body":
    'Puteți alege între trei setări pentru modulele cookie. Alegerea setării "standard" ne va permite să vă oferim cea mai bună experiență la vizitarea site-ului web.',
  "CookieMessage.settings.standard.title":
    "Standard (cea mai populara setare):",
  "CookieMessage.settings.standard.body":
    "Module cookie utilizate pentru autentificare, comandare, analiză, informări personalizate, medii de socializare și module cookie de la terțe părți, atât de pe teritoriul, cât și din afara Europei.",
  "CookieMessage.settings.restricted.title": "Restricționat",
  "CookieMessage.settings.restricted.body":
    "Module cookie utilizate pentru autentificare, comandare, analiza si informari personalizate.",
  "CookieMessage.settings.highly_restricted.title": "Foarte restricționat:",
  "CookieMessage.settings.highly_restricted.body":
    "Permiteti numai numarul minim de module cookie. Utilizate exclusiv pentru autentificare, comandare ?i pentru a permite functionarea site-ului web într-o masura rezonabila.",
  "CookieMessage.settings.options.title": "Iata ceea ce facem:",
  "CookieMessage.settings.option.1":
    "Utilizăm module cookie pentru a ne asigura că acest site web funcționează corect\n",
  "CookieMessage.settings.option.2": "Cercetam comportamentul utilizatorilor",
  "CookieMessage.settings.option.3": "Urmarim statistici personale",
  "CookieMessage.settings.option.4":
    "Afișăm informații care pot fi de interes\n",
  "CookieMessage.settings.option.5":
    "Utilizăm informații pentru reclamele noastre",
  "CookieMessage.settings.option.6": "Urmarim statistici anonime",
  "CookieMessage.settings.option.7": "Distribuim detaliile dvs. personale",
  "CookieMessage.settings.title": "Setari pentru modulele cookie",
  "CookiePage.url": "politica-de-confidentialitate-cookieuri",
};
